import React, { useState, useEffect, useRef } from 'react';
import { useData } from '../context/DataContext';

function SiNoBadge({ value }) {
  const yes = value === 'SI' || value === 'Si' || value === true;
  return (
    <span style={{
      background: yes ? '#dcfce7' : '#fee2e2',
      color:      yes ? '#16a34a' : '#dc2626',
      border:     `1px solid ${yes ? '#bbf7d0' : '#fecaca'}`,
      borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:700, whiteSpace:'nowrap'
    }}>
      {yes ? 'SI' : 'NO'}
    </span>
  );
}

function ModalStock({ item, onClose, onSave, onUploadFoto }) {
  const isEdit = !!item;
  const [form, setForm] = useState({
    modelo:     item?.modelo     || '',
    colores:    item?.colores    || '',
    sucursal1:  item?.sucursal1  || 'NO',
    sucursal2:  item?.sucursal2  || 'NO',
    foto_url:   item?.foto_url   || '',
  });
  const [saving, setSaving]   = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError]     = useState('');
  const fileRef = useRef();

  const handleFoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    setError('');
    const reader = new FileReader();
    reader.onload = async (ev) => {
      try {
        const base64 = ev.target.result.split(',')[1];
        const url = await onUploadFoto(base64, file.name, file.type);
        setForm(p => ({ ...p, foto_url: url }));
      } catch (err) {
        setError('No se pudo subir la imagen: ' + err.message);
      } finally {
        setUploading(false);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    if (!form.modelo.trim()) { setError('El modelo es obligatorio'); return; }
    setSaving(true);
    setError('');
    try {
      await onSave(form);
      onClose();
    } catch (err) {
      setError('Error al guardar: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background:'#fff', borderRadius:16, width:'100%', maxWidth:480, maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>
        {/* Header */}
        <div style={{ background:'#185fa5', padding:'20px 24px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <h2 style={{ margin:0, color:'#fff', fontSize:18, fontWeight:800 }}>{isEdit ? 'Editar modelo' : 'Nuevo modelo'}</h2>
          <button onClick={onClose} style={{ background:'rgba(255,255,255,0.2)', border:'none', color:'#fff', width:32, height:32, borderRadius:8, cursor:'pointer', fontSize:18 }}>×</button>
        </div>

        {/* Body */}
        <div style={{ flex:1, overflow:'auto', padding:24 }}>

          {/* Foto */}
          <p style={{ margin:'0 0 8px', fontSize:11, fontWeight:800, color:'#94a3b8', textTransform:'uppercase', letterSpacing:1 }}>Foto del modelo</p>
          <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:20 }}>
            <div style={{ width:72, height:72, borderRadius:12, background:'#f1f5f9', border:'2px dashed #cbd5e1', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
              {form.foto_url
                ? <img src={form.foto_url} alt={form.modelo} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                : <span style={{ fontSize:24 }}>📱</span>}
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              <input ref={fileRef} type="file" accept="image/*" onChange={handleFoto} style={{ display:'none' }} />
              <button onClick={() => fileRef.current.click()} disabled={uploading}
                style={{ padding:'8px 16px', background:'#fef9c3', color:'#854d0e', border:'1px solid #fde68a', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700, opacity: uploading ? 0.6 : 1 }}>
                {uploading ? 'Subiendo...' : '📁 Subir foto'}
              </button>
              {form.foto_url && (
                <button onClick={() => setForm(p => ({ ...p, foto_url:'' }))}
                  style={{ padding:'8px 16px', background:'#fee2e2', color:'#dc2626', border:'1px solid #fecaca', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
                  Quitar foto
                </button>
              )}
            </div>
          </div>

          {/* Modelo */}
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:800, color:'#94a3b8', marginBottom:5, textTransform:'uppercase', letterSpacing:0.5 }}>Modelo</label>
            <input value={form.modelo} onChange={e=>setForm(p=>({...p,modelo:e.target.value}))} placeholder="Ej. Samsung A15"
              style={{ width:'100%', padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', boxSizing:'border-box' }} />
          </div>

          {/* Colores */}
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:800, color:'#94a3b8', marginBottom:5, textTransform:'uppercase', letterSpacing:0.5 }}>Colores disponibles</label>
            <input value={form.colores} onChange={e=>setForm(p=>({...p,colores:e.target.value}))} placeholder="Ej. Negro, Azul, Verde"
              style={{ width:'100%', padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', boxSizing:'border-box' }} />
          </div>

          {/* Sucursales */}
          <div style={{ display:'flex', gap:14, marginBottom:6 }}>
            <div style={{ flex:1 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:800, color:'#94a3b8', marginBottom:5, textTransform:'uppercase', letterSpacing:0.5 }}>
                Sucursal Condesa
              </label>
              <select value={form.sucursal1} onChange={e=>setForm(p=>({...p,sucursal1:e.target.value}))}
                style={{ width:'100%', padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', background:'#fff', boxSizing:'border-box', cursor:'pointer' }}>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
              </select>
            </div>
            <div style={{ flex:1 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:800, color:'#94a3b8', marginBottom:5, textTransform:'uppercase', letterSpacing:0.5 }}>
                Sucursal Tecnoplaza
              </label>
              <select value={form.sucursal2} onChange={e=>setForm(p=>({...p,sucursal2:e.target.value}))}
                style={{ width:'100%', padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', background:'#fff', boxSizing:'border-box', cursor:'pointer' }}>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
              </select>
            </div>
          </div>

          {error && (
            <div style={{ marginTop:14, background:'#fee2e2', border:'1px solid #fecaca', borderRadius:8, padding:'10px 14px', color:'#dc2626', fontSize:12 }}>
              ⚠️ {error}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ display:'flex', gap:10, padding:'16px 24px', borderTop:'1px solid #e2e8f0' }}>
          <button onClick={onClose}
            style={{ flex:1, padding:'10px', border:'1px solid #e2e8f0', background:'#fff', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, color:'#475569' }}>
            Cancelar
          </button>
          <button onClick={handleSave} disabled={saving || uploading}
            style={{ flex:1, padding:'10px', background:'#185fa5', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700, opacity: saving||uploading ? 0.6 : 1 }}>
            {saving ? 'Guardando...' : isEdit ? 'Guardar cambios' : 'Agregar modelo'}
          </button>
        </div>
      </div>
    </div>
  );
}

function ModalConfirm({ titulo, mensaje, onCancel, onConfirm, loading }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:600, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}
      onClick={e => { if (e.target === e.currentTarget) onCancel(); }}>
      <div style={{ background:'#fff', borderRadius:16, width:'100%', maxWidth:380, padding:24 }}>
        <h3 style={{ margin:'0 0 8px', fontSize:16, fontWeight:800, color:'#0f172a' }}>{titulo}</h3>
        <p style={{ margin:'0 0 20px', fontSize:13, color:'#64748b' }}>{mensaje}</p>
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={onCancel}
            style={{ flex:1, padding:'10px', border:'1px solid #e2e8f0', background:'#fff', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, color:'#475569' }}>
            Cancelar
          </button>
          <button onClick={onConfirm} disabled={loading}
            style={{ flex:1, padding:'10px', background:'#dc2626', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700, opacity: loading ? 0.6 : 1 }}>
            {loading ? 'Eliminando...' : 'Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Inventario() {
  const { stock, stockLoading, stockError, cargarStock, crearStockItem, editarStockItem, eliminarStockItem, subirFotoStock } = useData();
  const [busqueda, setBusqueda] = useState('');
  const [modal, setModal]       = useState(null);   // { mode:'new'|'edit', item }
  const [toDelete, setToDelete] = useState(null);   // item
  const [deleting, setDeleting] = useState(false);
  const [toastMsg, setToastMsg] = useState('');

  useEffect(() => { cargarStock(); }, [cargarStock]);

  const toast = (msg) => { setToastMsg(msg); setTimeout(() => setToastMsg(''), 3000); };

  const filtrados = stock.filter(s => {
    const q = busqueda.toLowerCase();
    return !q || (s.modelo||'').toLowerCase().includes(q) || (s.colores||'').toLowerCase().includes(q);
  });

  const handleSave = async (form) => {
    if (modal.mode === 'edit') {
      await editarStockItem(modal.item.rowIndex, form);
      toast('Modelo actualizado');
    } else {
      await crearStockItem(form);
      toast('Modelo agregado');
    }
  };

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await eliminarStockItem(toDelete.rowIndex);
      toast('Modelo eliminado');
      setToDelete(null);
    } catch (e) {
      toast('Error al eliminar: ' + e.message);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div style={{ padding:'24px 24px 80px', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24, flexWrap:'wrap', gap:12 }}>
        <div>
          <h1 style={{ margin:0, fontSize:22, fontWeight:800, color:'#0f172a' }}>Inventario</h1>
          <p style={{ margin:'4px 0 0', color:'#94a3b8', fontSize:13 }}>{stock.length} modelos registrados</p>
        </div>
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={cargarStock} disabled={stockLoading}
            style={{ padding:'9px 18px', background:'#fff', color:'#185fa5', border:'1px solid #e2e8f0', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
            {stockLoading ? '⟳ Cargando...' : '⟳ Actualizar'}
          </button>
          <button onClick={() => setModal({ mode:'new', item:null })}
            style={{ padding:'9px 18px', background:'#185fa5', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
            + Nuevo modelo
          </button>
        </div>
      </div>

      {/* Buscador */}
      <div style={{ marginBottom:20 }}>
        <input value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar por modelo o color..."
          style={{ width:'100%', maxWidth:400, padding:'9px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', boxSizing:'border-box' }} />
      </div>

      {/* Error */}
      {stockError && (
        <div style={{ background:'#fee2e2', border:'1px solid #fecaca', borderRadius:10, padding:'12px 16px', color:'#dc2626', fontSize:13, marginBottom:16 }}>
          ⚠️ {stockError}
        </div>
      )}

      {/* Lista / Tabla */}
      {stockLoading && stock.length === 0 ? (
        <div style={{ textAlign:'center', padding:60, color:'#94a3b8' }}>
          <div style={{ fontSize:32, marginBottom:12 }}>⟳</div>
          <p>Cargando inventario...</p>
        </div>
      ) : filtrados.length === 0 ? (
        <div style={{ textAlign:'center', padding:60, color:'#94a3b8' }}>
          <div style={{ fontSize:40, marginBottom:12 }}>📦</div>
          <p style={{ fontWeight:600 }}>No hay modelos{busqueda ? ' con esa búsqueda' : ' registrados aún'}</p>
        </div>
      ) : (
        <div style={{ background:'#fff', borderRadius:12, boxShadow:'0 1px 3px rgba(0,0,0,0.08)', overflow:'hidden' }}>
          {/* Header de tabla */}
          <div style={{ display:'flex', alignItems:'center', gap:14, padding:'12px 18px', borderBottom:'1px solid #f1f5f9', fontSize:11, fontWeight:800, color:'#94a3b8', textTransform:'uppercase', letterSpacing:0.5 }}>
            <div style={{ width:44 }}></div>
            <div style={{ flex:1 }}>Modelo</div>
            <div style={{ flex:1 }}>Colores</div>
            <div style={{ width:110, textAlign:'center' }}>Condesa</div>
            <div style={{ width:110, textAlign:'center' }}>Tecnoplaza</div>
            <div style={{ width:90 }}></div>
          </div>

          {filtrados.map(s => (
            <div key={s.rowIndex} style={{ display:'flex', alignItems:'center', gap:14, padding:'12px 18px', borderBottom:'1px solid #f8fafc' }}>
              {/* Foto */}
              <div style={{ width:44, height:44, borderRadius:10, background:'#f1f5f9', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                {s.foto_url
                  ? <img src={s.foto_url} alt={s.modelo} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                  : <span style={{ fontSize:18 }}>📱</span>}
              </div>
              {/* Modelo */}
              <div style={{ flex:1, minWidth:0 }}>
                <p style={{ margin:0, fontWeight:700, fontSize:14, color:'#0f172a', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.modelo}</p>
              </div>
              {/* Colores */}
              <div style={{ flex:1, minWidth:0 }}>
                <p style={{ margin:0, fontSize:12, color:'#94a3b8', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.colores || '—'}</p>
              </div>
              {/* Sucursales */}
              <div style={{ width:110, textAlign:'center' }}><SiNoBadge value={s.sucursal1} /></div>
              <div style={{ width:110, textAlign:'center' }}><SiNoBadge value={s.sucursal2} /></div>
              {/* Acciones */}
              <div style={{ width:90, display:'flex', gap:6, justifyContent:'flex-end' }}>
                <button onClick={() => setModal({ mode:'edit', item:s })}
                  style={{ width:32, height:32, background:'#eff6ff', color:'#185fa5', border:'1px solid #bfdbfe', borderRadius:8, cursor:'pointer', fontSize:14 }}>
                  ✏️
                </button>
                <button onClick={() => setToDelete(s)}
                  style={{ width:32, height:32, background:'#fee2e2', color:'#dc2626', border:'1px solid #fecaca', borderRadius:8, cursor:'pointer', fontSize:14 }}>
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal nuevo/editar */}
      {modal && (
        <ModalStock
          item={modal.item}
          onClose={() => setModal(null)}
          onSave={handleSave}
          onUploadFoto={subirFotoStock}
        />
      )}

      {/* Modal confirmar eliminación */}
      {toDelete && (
        <ModalConfirm
          titulo="Eliminar modelo"
          mensaje={`¿Seguro que deseas eliminar "${toDelete.modelo}" del inventario? Esta acción no se puede deshacer.`}
          onCancel={() => setToDelete(null)}
          onConfirm={handleDelete}
          loading={deleting}
        />
      )}

      {/* Toast */}
      {toastMsg && (
        <div style={{ position:'fixed', bottom:60, left:'50%', transform:'translateX(-50%)', background:'#0f172a', color:'#fff', padding:'10px 20px', borderRadius:10, fontSize:13, fontWeight:600, zIndex:999, whiteSpace:'nowrap' }}>
          {toastMsg}
        </div>
      )}
    </div>
  );
}
